<template>
    <app-layout :nav_type="null" :footer_image="false">
        <!-- Hero Start -->
        <section class=" bg-circle-gradiant d-flex align-items-center bg-half-170 ">
            <div class="bg-overlay bg-overlay-white"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-5 col-md-8">
                        <div class="card login-page shadow rounded border-0">
                            <div class="card-body">
                                <h4 class="card-title text-center mb-4">Edit my information</h4>

                                <form class="row g-4" @submit.prevent="update">

                                    <div class="col-12">
                                        <div class="form-floating theme-form-floating log-in-form">
                                            <input type="text" class="form-control" id="name"
                                                   placeholder="Name" v-model="user.name"  :class="{ 'is-invalid' : isInvalid('name')}" required>
                                            <div class="invalid-feedback" v-if="isInvalid('name')">
                                                {{  isInvalid('name') }}
                                            </div>
                                            <label for="name">Name</label>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-floating theme-form-floating log-in-form">
                                            <input type="text" class="form-control pe-1" id="login-mobile" placeholder="5×××××"
                                                   aria-label="mobile" aria-describedby="mobile" v-model="user.mobile" dir="ltr">

                                            <label for="login-mobile">Phone number</label>
                                        </div>
                                    </div>


                                    <div class="col-12">
                                        <button class="btn  btn-primary w-100" type="submit">Save</button>
                                    </div>
                                </form>
                            </div>
                        </div><!---->
                    </div><!--end col-->
                </div><!--end row-->
            </div> <!--end container-->
        </section><!--end section-->
        <!-- Hero End -->
    </app-layout>
</template>

<script>
//import Apptoast from "../handling/toast";
import { useToast } from "vue-toastification";
import AppLayout from "../../app-layout.vue";
const toast = useToast();

// import alertErrors from "../handling/alert-errors";

export default {
    inject: ['auth'],
    components: {
        AppLayout
        // alertErrors,
    },
    data() {
        return {
            user: {},
            form_options: {},
            avatar: null,
            cover: null,
            validationErrors: null,
        }
    },
    created() {

        // if(this.auth.isLoggedIn() === false){
        //     this.$router.push({name: 'home'});
        // }

        axios.get('users/edit', {}).then(response => {
            this.user = response.data.data;
            this.form_options = response.data.elements;
        }, response => {

        });
    },
    watch: {
        '$userLoggedIn.value': function (newVal) {
            if (newVal === false) {
                this.$router.push({name: 'home'});
            }
        },
        'avatar': function () {

            if (this.avatar != null) {
                let formData = new FormData();
                formData.append('avatar', this.avatar);

                const id = toast.info({
                    props: {content: 'uploading ...'},
                }, {icon: 'fa-solid fa-cloud-arrow-up'});

                axios.post(`users/upload/avatar`,
                    formData
                ).then(response => {
                    toast.dismiss(id);

                    toast.success(response.data.message, {
                        timeout: 3000,
                    }, {icon: 'fa-solid fa-circle-check'});


                    this.auth.reGetUser();
                    this.avatar = null;

                }).catch(function (error) {
                    toast.dismiss(id);
                    if (error.response) {
                        toast.error(error.response.data.message, {
                            timeout: 3000,
                        }, {icon: 'fa-solid fa-circle-exclamation'});
                    }
                });
            }

        },
        'cover': function () {

            if (this.cover != null) {

                console.log(this.cover);
                let formData = new FormData();
                formData.append('cover', this.cover);

                const id = toast.info({
                    props: {content: 'uploading ...'},
                }, {icon: 'fa-solid fa-cloud-arrow-up'});

                axios.post(`users/upload/cover`,
                    formData
                ).then(response => {
                    toast.dismiss(id);

                    toast.success(response.data.message, {
                        timeout: 3000,
                    }, {icon: 'fa-solid fa-circle-check'});


                    this.auth.reGetUser();
                    this.cover = null;

                }).catch(function (error) {
                    toast.dismiss(id);
                    if (error.response) {
                        toast.error(error.response.data.message, {
                            timeout: 3000,
                        }, {icon: 'fa-solid fa-circle-exclamation'});
                    }
                });

            }
        },
    },
    methods: {
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        update() {

            const id = toast.info({
                props: {content: 'saving ...'},
            }, {icon: 'fa-solid fa-cloud-arrow-up'});

            const that = this;
            this.validationErrors = null;

            let formData = new FormData();
            Object.entries(this.user).forEach(([key, value]) => {
                formData.append(key, value);
            });

            axios.post(`users/update`,
                formData
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message, {
                    timeout: 3000,
                }, {icon: 'fa-solid fa-circle-check'});

                this.auth.reGetUser();
            }).catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors;
                    toast.error(error.response.data.message, {
                        timeout: 3000,
                    }, {icon: 'fa-solid fa-circle-exclamation'});
                }
            });
        }
    }
}
</script>
